import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, createTextVNode as _createTextVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createStaticVNode as _createStaticVNode } from "vue"

const _hoisted_1 = {
  class: "stepper stepper-pills stepper-column d-flex flex-column flex-xl-row flex-row-fluid",
  id: "kt_create_account_stepper",
  ref: "verticalWizardRef"
}
const _hoisted_2 = /*#__PURE__*/_createStaticVNode("<div class=\"d-flex justify-content-center bg-white rounded justify-content-xl-start flex-row-auto w-100 w-xl-300px w-xxl-400px me-9\"><div class=\"px-6 px-lg-10 px-xxl-15 py-20\"><div class=\"stepper-nav\"><div class=\"stepper-item current\" data-kt-stepper-element=\"nav\"><div class=\"stepper-line w-40px\"></div><div class=\"stepper-icon w-40px h-40px\"><i class=\"stepper-check fas fa-check\"></i><span class=\"stepper-number\">1</span></div><div class=\"stepper-label\"><h3 class=\"stepper-title\">Account Type</h3><div class=\"stepper-desc fw-bold\">Setup Your Account Details</div></div></div><div class=\"stepper-item\" data-kt-stepper-element=\"nav\"><div class=\"stepper-line w-40px\"></div><div class=\"stepper-icon w-40px h-40px\"><i class=\"stepper-check fas fa-check\"></i><span class=\"stepper-number\">2</span></div><div class=\"stepper-label\"><h3 class=\"stepper-title\">Basic Info</h3><div class=\"stepper-desc fw-bold\">Fill your basic details</div></div></div><div class=\"stepper-item\" data-kt-stepper-element=\"nav\"><div class=\"stepper-line w-40px\"></div><div class=\"stepper-icon w-40px h-40px\"><i class=\"stepper-check fas fa-check\"></i><span class=\"stepper-number\">3</span></div><div class=\"stepper-label\"><h3 class=\"stepper-title\">Business Info</h3><div class=\"stepper-desc fw-bold\"> Tell us about your business </div></div></div><div class=\"stepper-item\" data-kt-stepper-element=\"nav\"><div class=\"stepper-line w-40px\"></div><div class=\"stepper-icon w-40px h-40px\"><i class=\"stepper-check fas fa-check\"></i><span class=\"stepper-number\">4</span></div><div class=\"stepper-label\"><h3 class=\"stepper-title\">Team And Funding</h3><div class=\"stepper-desc fw-bold\">Tell us about your team</div></div></div><div class=\"stepper-item\" data-kt-stepper-element=\"nav\"><div class=\"stepper-line w-40px\"></div><div class=\"stepper-icon w-40px h-40px\"><i class=\"stepper-check fas fa-check\"></i><span class=\"stepper-number\">5</span></div><div class=\"stepper-label\"><h3 class=\"stepper-title\">Completed</h3><div class=\"stepper-desc fw-bold\">Woah, we are here</div></div></div></div></div></div>", 1)
const _hoisted_3 = { class: "d-flex flex-row-fluid flex-center bg-white rounded" }
const _hoisted_4 = {
  class: "current",
  "data-kt-stepper-element": "content"
}
const _hoisted_5 = { "data-kt-stepper-element": "content" }
const _hoisted_6 = { "data-kt-stepper-element": "content" }
const _hoisted_7 = { "data-kt-stepper-element": "content" }
const _hoisted_8 = { "data-kt-stepper-element": "content" }
const _hoisted_9 = { class: "d-flex flex-stack pt-10" }
const _hoisted_10 = { class: "mr-2" }
const _hoisted_11 = { class: "svg-icon svg-icon-4 me-1" }
const _hoisted_12 = /*#__PURE__*/_createTextVNode(" Back ")
const _hoisted_13 = { class: "indicator-label" }
const _hoisted_14 = /*#__PURE__*/_createTextVNode(" Submit ")
const _hoisted_15 = { class: "svg-icon svg-icon-3 ms-2 me-0" }
const _hoisted_16 = /*#__PURE__*/_createElementVNode("span", { class: "indicator-progress" }, [
  /*#__PURE__*/_createTextVNode(" Please wait... "),
  /*#__PURE__*/_createElementVNode("span", { class: "spinner-border spinner-border-sm align-middle ms-2" })
], -1)
const _hoisted_17 = {
  key: 1,
  type: "submit",
  class: "btn btn-lg btn-primary"
}
const _hoisted_18 = /*#__PURE__*/_createTextVNode(" Continue ")
const _hoisted_19 = { class: "svg-icon svg-icon-4 ms-1 me-0" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_Step1 = _resolveComponent("Step1")!
  const _component_FounderStep1 = _resolveComponent("FounderStep1")!
  const _component_FounderStep2 = _resolveComponent("FounderStep2")!
  const _component_FounderStep3 = _resolveComponent("FounderStep3")!
  const _component_Step5 = _resolveComponent("Step5")!
  const _component_inline_svg = _resolveComponent("inline-svg")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _hoisted_2,
    _createElementVNode("div", _hoisted_3, [
      _createElementVNode("form", {
        class: "py-20 w-100 w-xl-700px px-9",
        novalidate: "novalidate",
        id: "kt_create_account_form",
        onSubmit: _cache[2] || (_cache[2] = 
//@ts-ignore
(...args) => (_ctx.handleStep && _ctx.handleStep(...args)))
      }, [
        _createElementVNode("div", _hoisted_4, [
          _createVNode(_component_Step1, { onOnChangeAccountType: _ctx.onChangeAccountType }, null, 8, ["onOnChangeAccountType"])
        ]),
        _createElementVNode("div", _hoisted_5, [
          _createVNode(_component_FounderStep1)
        ]),
        _createElementVNode("div", _hoisted_6, [
          _createVNode(_component_FounderStep2)
        ]),
        _createElementVNode("div", _hoisted_7, [
          _createVNode(_component_FounderStep3)
        ]),
        _createElementVNode("div", _hoisted_8, [
          _createVNode(_component_Step5)
        ]),
        _createElementVNode("div", _hoisted_9, [
          _createElementVNode("div", _hoisted_10, [
            (_ctx.currentStepIndex > 1)
              ? (_openBlock(), _createElementBlock("button", {
                  key: 0,
                  type: "button",
                  class: "btn btn-lg btn-light-primary me-3",
                  "data-kt-stepper-action": "previous",
                  onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.previousStep && _ctx.previousStep(...args)))
                }, [
                  _createElementVNode("span", _hoisted_11, [
                    _createVNode(_component_inline_svg, { src: "media/icons/duotune/arrows/arr063.svg" })
                  ]),
                  _hoisted_12
                ]))
              : _createCommentVNode("", true)
          ]),
          _createElementVNode("div", null, [
            (_ctx.currentStepIndex === _ctx.totalSteps - 1)
              ? (_openBlock(), _createElementBlock("button", {
                  key: 0,
                  type: "button",
                  class: "btn btn-lg btn-primary me-3",
                  "data-kt-stepper-action": "submit",
                  ref: "submitButtonRef",
                  onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.formSubmit()))
                }, [
                  _createElementVNode("span", _hoisted_13, [
                    _hoisted_14,
                    _createElementVNode("span", _hoisted_15, [
                      _createVNode(_component_inline_svg, { src: "media/icons/duotune/arrows/arr064.svg" })
                    ])
                  ]),
                  _hoisted_16
                ], 512))
              : (_openBlock(), _createElementBlock("button", _hoisted_17, [
                  _hoisted_18,
                  _createElementVNode("span", _hoisted_19, [
                    _createVNode(_component_inline_svg, { src: "media/icons/duotune/arrows/arr064.svg" })
                  ])
                ]))
          ])
        ])
      ], 32)
    ])
  ], 512))
}